
import * as DOMPurify from "dompurify";
import { ConfigService } from '@rightship-tech/common-ui/services/basic/config.service';
import { DataType } from '@rightship-tech/common-ui/models/queries.models';
import { PropertyMetaModel } from "../models/form.models";
import { Reflection } from '@rightship-tech/common-ui/helpers/reflection';
import moment from "moment";

export class RightShipTransformHtmlHelper {

    public static transformHtml(html: string,
        model: any,
        properties: PropertyMetaModel[],
        callback: (element: HTMLElement, property: string, dataType: DataType) => void = null, modelName: string = "model"): HTMLElement {
        if (!model || !properties || properties.length == 0) {
            return null;
        }

        const props: { [prop: string]: PropertyMetaModel; } = {};
        properties.forEach(p => {
            props[p.camelCasePropertyName] = p;
        });
        const div = document.createElement('div');
        div.innerHTML = DOMPurify.sanitize(html);
        this.wrapSpan(div, 0);
        const variables = $(div).find('.variable-placeholder').toArray().map(el => <HTMLElement>el);
        const length = variables.length;

        for (let index = length - 1; index >= 0; index--) {
            const element = variables[index];
            const propName = element.getAttribute('data-property-name');
            if (props[propName]) {
                const parameter = props[propName].parameter;
                let format = element.getAttribute('data-format');

                let defaultValue: any = element.getAttribute('data-default-value');
                const startLabel = element.getAttribute('data-start-label');

                const type: DataType = props[propName].type;
                let elementTransformed: HTMLElement = document.createElement('p');

                let value = modelName + "." + propName;
                let modelValue = model[propName];
                if(modelValue == undefined){
                    modelValue = model["dynamicValues"]? model["dynamicValues"][propName]: null;
                    value = modelName + ".dynamicValues." + propName;
                }
                switch (type) {
                    case DataType.Boolean: 
                        {
                            elementTransformed.innerHTML = modelValue == true ? "Yes" : "No";
                        }
                        break;
                    case DataType.Default:
                    case DataType.Password:
                    case DataType.Number:
                    case DataType.Double:
                        {
                            const val = model[propName];
                            if (propName == "numberOfDaysDetained") {
                                const days = Math.floor(val);
                                const hours = Math.round((val % 1.0) * 24);
                                elementTransformed.innerHTML = `${days} ${days == 1 ? 'day' : 'days'}${hours > 0 ? ' ' + hours : ''}${hours == 0 ? '' : (hours == 1 ? ' hour' : ' hours')}`;
                            } else if (val) {
                                elementTransformed.innerHTML = (startLabel != null && startLabel.trim() != ''? startLabel + ' ': '') + val;
                            }
                        }
                        break;
                    case DataType.Lookup: 
                    case DataType.HierarchicalLookup:
                        {
                            elementTransformed.setAttribute('lookup-property', `query: ${parameter}; id.bind: ${value};`);                           
                        }
                        break;
                    case DataType.Date:
                    case DataType.DateTime:
                        {
                            if (!format) {
                                format = type == DataType.DateTime ? ConfigService.instance().config.common.defaultDateTimeFormat : ConfigService.instance().config.common.defaultDateFormat;
                            }
                            const val = model[propName];
                            const date = moment(val).format(format);
                            elementTransformed.innerHTML = date;
                        }
                        break;
                }
                model[propName] = defaultValue !== undefined && model[propName] === undefined && element.hasAttribute('data-default-value') ? defaultValue : model[propName];
                
                const className = Reflection.kebabCase(propName);
                if (elementTransformed) {
                    elementTransformed.setAttribute('class', 'onboarding-client-variable ' + className);

                    elementTransformed.classList.add('transformed-element');
                    if(element && element.parentNode) {
                        element.parentNode.insertBefore(elementTransformed, element.nextSibling);
                        element.parentNode.removeChild(element);
                    }

                    if (callback) {
                        callback(elementTransformed, propName, type);
                    }
                }

                //To add the data-type of the component in order to do some style-related changes - DEL-2197
                div.classList.add('data-type-'+ type);
            }

        }
        return div;
    }

    public static wrapSpan(node, index) {
        if (node.nodeName === '#text') {
            const text = node.textContent;
            const s = document.createElement('span');
            s.classList.add('text-node');
            s.innerHTML = text;
            if(node && node.parentNode){
                node.parentNode.insertBefore(s, node.parentNode.childNodes[index]);
                node.parentNode.removeChild(node);
            }
        } else if (!node.classList || !node.classList.contains('variable-placeholder')) {
            const length = node.childNodes.length;
            for (let i = 0; i < length; i++)
                this.wrapSpan(node.childNodes[i], i);
        }
    }
}